<template>
  <UserShell
    title="资产评估申请"
    subtitle="填写个人运营数据及证明材料，提交后台审核评估"
    :profile="profile"
    :menu-items="menuItems"
    active-key="apply"
    center-path="/user/personal"
  >
    <div class="hero-row">
      <img class="hero-avatar" :src="profile.avatar" alt="头像" />
      <div class="hero-meta">
        <div class="hero-name-row">
          <div class="hero-name">{{ profile.name }}</div>
        </div>
        <div class="hero-subline">平台ID：{{ basicInfo.platformId }} | 注册时间：{{ basicInfo.registerDate }}</div>
      </div>
    </div>

    <div class="notice-box">
      <img class="notice-icon" :src="tipIcon" alt="提示" />
      <span>提示：请如实填写您的运营数据，评估结果将影响您的商业合作机会与扶持资格。</span>
    </div>

    <div v-if="currentStatus === 'rejected' && rejectReason" class="reject-box">
      <span class="reject-label">驳回原因：</span>
      <span class="reject-text">{{ rejectReason }}</span>
    </div>

    <section class="form-section">
      <div class="form-grid">
        <div class="field-item">
          <label>资产名称 <span class="required">*</span></label>
          <el-input v-model="form.assetName" class="control" :disabled="readonlyMode" />
        </div>
        <div class="field-item">
          <label>资产类别 <span class="required">*</span></label>
          <el-input v-model="form.assetCategory" class="control" :disabled="readonlyMode" />
        </div>
        <div class="field-item">
          <label>资产权属人 <span class="required">*</span></label>
          <el-input v-model="form.ownerName" class="control" :disabled="readonlyMode" />
        </div>
        <div class="field-item">
          <label>权属人身份证号 <span class="required">*</span></label>
          <el-input v-model="form.ownerIdNo" class="control" :disabled="readonlyMode" />
        </div>
        <div class="field-item">
          <label>常住所在地 <span class="required">*</span></label>
          <el-input v-model.trim="form.residence" class="control" :disabled="readonlyMode" />
        </div>
        <div class="field-item">
          <label>行业荣誉/认证</label>
          <el-input v-model.trim="form.honors" class="control" :disabled="readonlyMode" />
        </div>
        <div class="field-item">
          <label>主播类型 <span class="required">*</span></label>
          <el-select v-model="form.streamerType" placeholder="请选择（全职/兼职）" class="control" :disabled="readonlyMode">
            <el-option v-for="option in anchorTypeOptions" :key="option.value" :label="option.label" :value="option.value" />
          </el-select>
        </div>
        <div class="field-item">
          <label>主营内容方向 <span class="required">*</span></label>
          <el-select v-model="form.contentDirection" placeholder="请选择" class="control" :disabled="readonlyMode">
            <el-option v-for="option in businessDirectionOptions" :key="option.value" :label="option.label" :value="option.value" />
          </el-select>
        </div>
      </div>
    </section>

    <section class="form-section">
      <div class="section-header between">
        <div class="section-title-row">
          <!-- <img class="section-icon" :src="applyIcon" alt="平台信息" /> -->
          <span>各平台账号信息</span>
          <span class="section-note">（至少填写一个平台）</span>
        </div>
        <button v-if="!readonlyMode" type="button" class="mini-primary-btn" @click="addAccount">增加平台账号</button>
      </div>

      <div v-for="(account, index) in form.accounts" :key="account.id" class="account-panel">
        <div class="account-grid">
          <div class="field-item">
            <label>平台名称 <span class="required">*</span></label>
            <el-select v-model="account.platform" placeholder="请选择平台" class="control" :disabled="readonlyMode">
              <el-option v-for="option in platformOptions" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>
          </div>
          <div class="field-item">
            <label>主播昵称 <span class="required">*</span></label>
            <el-input v-model.trim="account.nickname" placeholder="请输入" class="control" :disabled="readonlyMode" />
          </div>
          <div class="field-item">
            <label>平台ID <span class="required">*</span></label>
            <el-input v-model.trim="account.platformId" placeholder="请输入" class="control" :disabled="readonlyMode" />
          </div>
          <div class="field-item">
            <label>粉丝数量 <span class="required">*</span></label>
            <el-input v-model.trim="account.fansCount" placeholder="请输入粉丝数量(如:126万)" class="control" :disabled="readonlyMode" />
          </div>
          <div class="field-item field-item-wide">
            <label>垂类赛道 <span class="required">*</span></label>
            <el-select v-model="account.verticalTrack" placeholder="请选择" class="control" :disabled="readonlyMode">
              <el-option v-for="option in categoryOptions" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>
          </div>
        </div>
        <button v-if="!readonlyMode && form.accounts.length > 1" type="button" class="remove-account-btn" @click="removeAccount(index)">删除账号</button>
      </div>
    </section>

    <section class="form-section">
      <div class="section-title-row standalone">
        <img class="section-icon" :src="operationIcon" alt="主播运营情况" />
        <span>主播运营情况</span>
      </div>

      <div class="textarea-list">
          <div v-for="item in operationFields" :key="item.prop" class="textarea-item">
            <label>{{ item.label }} <span class="required">*</span></label>
            <div class="textarea-wrap">
            <el-input
              v-model.trim="form.operation[item.prop]"
              type="textarea"
              :rows="3"
              :maxlength="item.maxlength"
              :placeholder="item.placeholder"
              :disabled="readonlyMode"
              class="textarea-control"
            />
            <span class="textarea-count">{{ getLength(form.operation[item.prop]) }}/{{ item.maxlength }}</span>
          </div>
        </div>
		<div class="textarea-item">
			<label>证明材料<span class="required">*</span></label>
			
			<div class="upload-area">
			  <div class="upload-grid">
			    <button
			      v-for="(item, index) in form.evidenceFiles"
			      :key="item.key"
			      type="button"
			      class="proof-card"
			      :disabled="readonlyMode"
			      @click="openFilePicker(item.key)"
			    >
			      <img
			        v-if="item.url && isImageFile(item.url, item.fileName)"
			        class="proof-image uploaded"
			        :src="item.url"
			        :alt="item.fileName || item.label"
					referrerpolicy="no-referrer"
			      />
			      <div v-else-if="item.url" class="proof-document">
			        <div class="proof-document-ext">{{ getFileExtension(item.fileName || item.url) }}</div>
			        <div class="proof-document-name">{{ getDisplayFileName(item.fileName || item.url) }}</div>
			      </div>
			      <img v-else class="proof-image" :src="uploadImages[index]" :alt="item.label" />
			    </button>
			  </div>
			  <input
			    v-for="item in form.evidenceFiles"
			    :key="`${item.key}-input`"
			    :ref="`fileInput_${item.key}`"
			    type="file"
			    class="file-input"
			    accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
			    @change="handleFileChange($event, item.key)"
			  />
			  <div class="upload-tip">点击上传，上传格式为png、jpg、jpeg、pdf、word；文件大小不能超过10M，可同时上传最多3个文件。收入证明需提供背书账号的后台收益截图与银行卡流水入账证明，权属证明需提供账号后台信息截图与实名认证截图，已有商业/品牌合作请提供合作协议/合同证明文件。</div>
			</div>
		</div>
		
      </div>
    </section>

    <section class="form-section">
      <div class="section-title-row standalone">
        <span>收入预测 <em>（综合多平台数据测算）</em></span>
      </div>

      <div class="forecast-panel">
        <div class="form-grid">
          <div class="field-item">
            <label>短期收益 <span class="required">*</span></label>
            <el-input v-model.trim="form.forecast.shortTerm" placeholder="请输入未来6个月收益（如:126万元）" class="control" :disabled="readonlyMode" />
          </div>
          <div class="field-item">
            <label>全生命周期收益 <span class="required">*</span></label>
            <el-input v-model.trim="form.forecast.lifecycle" placeholder="请输入未来3年收益（如:626万元）" class="control" :disabled="readonlyMode" />
          </div>
        </div>

        <div class="textarea-item compact-top">
          <label>收益测算依据 <span class="required">*</span></label>
          <div class="textarea-wrap">
            <el-input
              v-model.trim="form.forecast.basis"
              type="textarea"
              :rows="3"
              :maxlength="200"
              placeholder="请输入，200个字以内"
              :disabled="readonlyMode"
              class="textarea-control"
            />
            <span class="textarea-count">{{ getLength(form.forecast.basis) }}/200</span>
          </div>
        </div>
      </div>
    </section>

    <div v-if="!readonlyMode" class="footer-actions">
      <button type="button" class="footer-btn ghost" :disabled="isSaving || isSubmitting" @click="handleSave">{{ isSaving ? '保存中...' : '保存' }}</button>
      <button type="button" class="footer-btn primary" :disabled="isSaving || isSubmitting" @click="handleSubmit">{{ isSubmitting ? '提交中...' : '提交评估申请' }}</button>
    </div>
  </UserShell>
</template>

<script>
import UserShell from './components/UserShell.vue';
import operationIcon from '@/assets/img/user/运营icon.png';
import tipIcon from '@/assets/img/user/提示.png';
import uploadImageA from '@/assets/img/user/上传.png';
import uploadImageB from '@/assets/img/user/上传(1).png';
import uploadImageC from '@/assets/img/user/上传(2).png';
import { uploadMemberFile } from '@/api/user';
import {
  anchorTypeOptions,
  businessDirectionOptions,
  categoryOptions,
  createEmptyApplicationAccount,
  createEmptyApplicationForm,
  createPersonalBasicInfo,
  createPersonalMenu,
  createPersonalProfile,
  platformOptions
} from './personalShared';
import {
  getApplicationById,
  getApplicationDraft,
  saveApplicationDraft,
  submitApplication
} from './personalApplicationStore';

function cloneDeep(value) {
  return JSON.parse(JSON.stringify(value));
}

export default {
  name: 'PersonalAssetApplication',
  components: { UserShell },
  data() {
    return {
      operationIcon,
      tipIcon,
      uploadImages: [uploadImageA, uploadImageB, uploadImageC],
      profile: createPersonalProfile(),
      basicInfo: createPersonalBasicInfo(),
      menuItems: createPersonalMenu(),
      platformOptions,
      categoryOptions,
      anchorTypeOptions,
      businessDirectionOptions,
      pageMode: 'new',
      currentRecordId: '',
      currentStatus: '',
      rejectReason: '',
      form: createEmptyApplicationForm(),
      isSaving: false,
      isSubmitting: false,
      operationFields: [
        {
          prop: 'totalFans',
          label: '全网粉丝总数',
          maxlength: 60,
          placeholder: '请描述您全网平台账号的总粉丝量'
        },
        {
          prop: 'worksStats',
          label: '全网作品总播放量与作品数量',
          maxlength: 60,
          placeholder: '请描述您全网作品总播放量与作品数量，200个字以内'
        },
        {
          prop: 'liveSessionsStats',
          label: '近一年直播场次与场均观看人数',
          maxlength: 200,
          placeholder: '请描述您的月均直播场次情况，例如:20场/月，其中带货直播15场、日常直播5场，200个字以内'
        },
        {
          prop: 'monthlyLiveHours',
          label: '月均直播时长',
          maxlength: 200,
          placeholder: '请描述您的月均直播时长，例如:80小时/月，场均4小时，200个字以内'
        },
        {
          prop: 'fanGrowth',
          label: '粉丝增长情况',
          maxlength: 200,
          placeholder: '请描述您的粉丝增长情况，例如:快速增长（月增10%以上），近三月累计新增粉丝50万，当前粉丝共102万等，200个字以内'
        },
        {
          prop: 'commercialCooperation',
          label: '近一年商业合作情况',
          maxlength: 200,
          placeholder: '请描述您近一年的商业合作情况，例如:活跃（月均5单以上），主要合作品牌包含XX、XX等，200个字以内'
        },
        {
          prop: 'annualIncome',
          label: '近一年收入情况',
          maxlength: 200,
          placeholder: '请描述您近一年的收入情况，例如:100万元以上，其中直播带货收入占比约70%，200个字以内'
        }
      ]
    };
  },
  computed: {
    readonlyMode() {
      return this.pageMode === 'view' && this.currentStatus !== 'approved';
    }
  },
  created() {
    this.refreshProfile();
    this.initPage();
  },
  methods: {
    refreshProfile() {
      this.profile = createPersonalProfile();
      this.basicInfo = createPersonalBasicInfo();
    },
    async initPage() {
      const { mode, id } = this.$route.query;
      this.pageMode = mode === 'view' ? 'view' : mode === 'edit' ? 'edit' : 'new';
      this.currentRecordId = id || '';
      this.currentStatus = '';
      this.rejectReason = '';

      try {
        if ((this.pageMode === 'edit' || this.pageMode === 'view') && this.currentRecordId) {
          const record = await getApplicationById(this.currentRecordId);
          if (!record) {
            this.$message.warning('未找到对应申请记录');
            this.$router.replace('/user/personal/applications');
            return;
          }
          this.currentStatus = record.status || (record.raw && record.raw.status) || '';
          this.rejectReason = record.raw && record.raw.reject_reason ? record.raw.reject_reason : '';
          this.form = this.hydrateForm(record.form);
          return;
        }

        const draft = await getApplicationDraft();
        this.form = this.hydrateForm(draft || createEmptyApplicationForm({ useCachedAccounts: true }), { useCachedAccounts: true });
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '获取申请信息失败');
      }
    },
    hydrateForm(source, options = {}) {
      const base = createEmptyApplicationForm({ useCachedAccounts: !!options.useCachedAccounts });
      const form = cloneDeep(source || base);
      return {
        ...base,
        ...form,
        residence: form.residence || '',
        honors: form.honors || '',
        streamerType: form.streamerType || '',
        contentDirection: form.contentDirection || '',
        accounts: Array.isArray(form.accounts) && form.accounts.length
          ? form.accounts.map(item => ({ ...createEmptyApplicationAccount(), ...item }))
          : base.accounts.map(item => ({ ...createEmptyApplicationAccount(), ...item })),
        operation: {
          ...base.operation,
          ...(form.operation || {})
        },
        evidenceFiles: base.evidenceFiles.map(item => {
          const match = Array.isArray(form.evidenceFiles) ? form.evidenceFiles.find(file => file.key === item.key) : null;
          return { ...item, ...(match || {}) };
        }),
        forecast: {
          ...base.forecast,
          ...(form.forecast || {})
        }
      };
    },
    getLength(value) {
      return String(value || '').length;
    },
    getSourceEvaluationId() {
      return ['approved', 'rejected'].includes(this.currentStatus) ? this.currentRecordId : undefined;
    },
    isImageFile(url, fileName) {
      return ['png', 'jpg', 'jpeg'].includes(this.getFileExtension(fileName || url).toLowerCase());
    },
    getFileExtension(value) {
      const source = String(value || '').split('?')[0];
      const segments = source.split('.');
      const extension = segments.length > 1 ? segments.pop() : '';
      return String(extension || 'FILE').toUpperCase();
    },
    getDisplayFileName(value) {
      const source = String(value || '').split('?')[0];
      const segments = source.split('/');
      return segments[segments.length - 1] || source || '已上传文件';
    },
    addAccount() {
      this.form.accounts.push(createEmptyApplicationAccount());
    },
    removeAccount(index) {
      if (this.form.accounts.length === 1) {
        return;
      }
      this.form.accounts.splice(index, 1);
    },
    openFilePicker(key) {
      if (this.readonlyMode) {
        return;
      }
      const ref = this.$refs[`fileInput_${key}`];
      const input = Array.isArray(ref) ? ref[0] : ref;
      if (input) {
        input.click();
      }
    },
    handleFileChange(event, key) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }
      const allowExt = ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'];
      const ext = file.name.split('.').pop().toLowerCase();
      if (!allowExt.includes(ext)) {
        this.$message.warning('请上传 png、jpg、jpeg、pdf、word 格式文件');
        event.target.value = '';
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.warning('文件大小不能超过10M');
        event.target.value = '';
        return;
      }

      const target = this.form.evidenceFiles.find(item => item.key === key);
      if (!target) {
        event.target.value = '';
        return;
      }

      target.fileName = '上传中...';
      this.$forceUpdate();

      uploadMemberFile(file, 'evidence')
        .then(response => {
          const data = response && typeof response === 'object' && Object.prototype.hasOwnProperty.call(response, 'data')
            ? response.data
            : response;
          const fileUrl = typeof data === 'string'
            ? data
            : (data && (data.url || data.full_url || data.path || data.location)) || '';

          if (!fileUrl) {
            throw new Error('上传成功，但未返回文件地址');
          }

          target.url = fileUrl;
          target.fileName = file.name;
          this.$message.success('文件上传成功');
        })
        .catch(error => {
          target.url = '';
          target.fileName = '';
          this.$message.error(error && error.message ? error.message : '文件上传失败');
        })
        .finally(() => {
          event.target.value = '';
        });
    },
    validateForm() {
      if (!this.form.assetName || !this.form.assetCategory || !this.form.ownerName || !this.form.ownerIdNo || !this.form.residence) {
        this.$message.warning('请完整填写基础信息');
        return false;
      }
      if (String(this.form.ownerIdNo).includes('*')) {
        this.$message.warning('请填写完整的权属人身份证号');
        return false;
      }
      if (!this.form.streamerType) {
        this.$message.warning('请选择主播类型');
        return false;
      }
      if (!this.form.contentDirection) {
        this.$message.warning('请选择主营内容方向');
        return false;
      }
      for (let index = 0; index < this.form.accounts.length; index += 1) {
        const account = this.form.accounts[index];
        if (!account.platform || !account.nickname || !account.platformId || !account.fansCount || !account.verticalTrack) {
          this.$message.warning(`请完整填写第${index + 1}个平台账号信息`);
          return false;
        }
      }
      for (let index = 0; index < this.operationFields.length; index += 1) {
        const item = this.operationFields[index];
        if (!this.form.operation[item.prop]) {
          this.$message.warning(`请填写${item.label}`);
          return false;
        }
      }
      if (!this.form.evidenceFiles.some(item => item.url)) {
        this.$message.warning('请至少上传一份证明材料');
        return false;
      }
      if (!this.form.forecast.shortTerm || !this.form.forecast.lifecycle || !this.form.forecast.basis) {
        this.$message.warning('请完整填写收入预测');
        return false;
      }
      return true;
    },
    async handleSave() {
      if (this.readonlyMode || this.isSaving) {
        return;
      }

      this.isSaving = true;
      try {
        const draft = await saveApplicationDraft(cloneDeep(this.form), this.getSourceEvaluationId());
        if (draft) {
          this.form = this.hydrateForm(draft);
        }
        this.$message.success('草稿已保存');
      } catch (error) {
        const message = error && error.message ? error.message : '';
        this.$message.error(/id\s*card.*格式不正确/i.test(message) ? '身份证不正确' : (message || '保存草稿失败'));
      } finally {
        this.isSaving = false;
      }
    },
    async handleSubmit() {
      if (this.readonlyMode || this.isSubmitting || !this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      try {
        await submitApplication(cloneDeep(this.form), this.getSourceEvaluationId());
        this.$message.success('评估申请已提交');
        this.$router.push('/user/personal/applications');
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '评估申请提交失败');
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  watch: {
    '$route.fullPath'() {
      this.refreshProfile();
      this.initPage();
    }
  }
};
</script>

<style lang="scss" scoped>
.hero-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 28px;
  padding-bottom: 26px;
  border-bottom: 1px solid #e6e8ee;
}

.hero-avatar {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  background: conic-gradient(from 0deg, #9f64ff, #528aff);
  padding: 2px;
  box-sizing: border-box;
}

.hero-name-row {
  display: flex;
  align-items: center;
  gap: 18px;
}

.hero-name {
  font-size: 22px;
  font-weight: 600;
  color: #1e293b;
}

.hero-tag {
  width: 82px;
  height: 28px;
}

.hero-subline {
  margin-top: 8px;
  font-size: 14px;
  color: #84899e;
}

.notice-box {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  margin-top: 22px;
  padding: 0 16px;
  border: 1px solid #B5A5FF;
  border-radius: 10px;
  background: #F3F3FF;
  color: #7E65ED;
  font-size: 14px;
}

.reject-box {
  margin-top: 16px;
  color: #ef4444;
  font-size: 14px;
  line-height: 1.6;
}

.reject-label {
  font-weight: 600;
}

.reject-text {
  word-break: break-all;
}

.notice-icon{
	  width: 24px;
	  height: 24px;
}
.section-icon {
  width: 18px;
  height: 18px;
}

.form-section {
  margin-top: 32px;
}

.form-grid,
.account-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 22px;
}

.field-item {
  min-width: 0;
}

.field-item-wide {
  grid-column: 1 / 2;
}

.field-item label,
.textarea-item label {
  display: block;
  margin-bottom: 10px;
  color: #1E293B;
  font-size: 16px;
  font-weight: 600;
}

.required {
  color: #D06BF7;
}

.control {
  width: 100%;
}

.control ::v-deep .el-input__inner,
.control ::v-deep .el-textarea__inner {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.control ::v-deep .el-input__inner {
  height: 45px;
  font-weight: 400;
  font-size: 14px;
  color: #1E293B;
  
}

.section-header {
  display: flex;
  align-items: center;
}

.between {
  justify-content: space-between;
}

.section-title-row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
}

.standalone {
  margin-bottom: 18px;
}

.section-note {
  color: #696E83;
  font-size: 12px;
  font-weight: 400;
}

.mini-primary-btn {
  min-width: 114px;
  height: 30px;
  border: 0;
  border-radius: 8px;
  background: #6f68f3;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.account-panel{
  position: relative;
  margin-top: 16px;
  padding: 18px 18px 20px;
  border-radius: 12px;
  background: #f8fafc;
}
.forecast-panel {
  position: relative;
  margin-top: 0px;
  padding: 18px 18px 20px;
  width: 794px;
  height: 306px;
  background: #F8F9FC;
  border-radius: 10px 10px 10px 10px;
}

.forecast-panel ::v-deep .el-input__inner{
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: #ffffff;
}

.remove-account-btn {
  margin-top: 14px;
  border: 0;
  background: transparent;
  color: #6f68f3;
  font-size: 14px;
  cursor: pointer;
}

.textarea-list {
  display: grid;
  gap: 24px;
  width: 796px;
  background: #F8F9FC;
  border-radius: 10px 10px 10px 10px;
  padding: 24px 28px;
}

.textarea-item {
  margin-top: 2px;
}

.compact-top {
  margin-top: 18px;
}

.textarea-wrap {
  position: relative;
}

.textarea-control ::v-deep .el-textarea__inner {
 height: 92px;
 background: #FFFFFF;
 border-radius: 4px 4px 4px 4px;
 border: 1px solid #E2E8F0;
 color: #1E293B;
}

.textarea-count {
  position: absolute;
  right: 12px;
  bottom: 10px;
  color: #b0b7ca;
  font-size: 12px;
}

.upload-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.proof-card {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 120px;
  height: 120px;
  cursor: pointer;
  border: 0;
  border-radius: 10px;
  background: #f8fafc;
}

.proof-card:disabled {
  cursor: default;
}

.proof-image {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.proof-image.uploaded {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.proof-document {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  background: linear-gradient(180deg, #f5f3ff 0%, #ece8ff 100%);
  color: #5b52d9;
  text-align: center;
  box-sizing: border-box;
}

.proof-document-ext {
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(111, 104, 243, 0.12);
  font-size: 12px;
  font-weight: 600;
}

.proof-document-name {
  margin-top: 10px;
  font-size: 12px;
  line-height: 1.4;
  word-break: break-all;
}

.proof-label {
  margin-top: 8px;
  color: #9098b4;
  font-size: 12px;
  line-height: 1.5;
}

.file-input {
  display: none;
}

.upload-tip {
  margin-top: 8px;
  font-weight: 400;
  font-size: 12px;
  color: #999FB8;
  line-height: 22px;
  text-align: left;
}

.section-title-row em {
  color: #a0a8c3;
  font-style: normal;
  font-size: 12px;
  font-weight: 400;
}

.footer-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 34px;
}

.footer-btn {
  min-width: 92px;
  height: 40px;
  padding: 0 18px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.footer-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.footer-btn.ghost {
  border: 1px solid #d8dfef;
  background: #fff;
  color: #6b7280;
}

.footer-btn.primary {
  border: 0;
  background: #6f68f3;
  color: #fff;
}

@media (max-width: 760px) {
  .hero-row,
  .hero-name-row,
  .between {
    flex-direction: column;
    align-items: flex-start;
  }

  .form-grid,
  .account-grid {
    grid-template-columns: 1fr;
  }

  .field-item-wide {
    grid-column: auto;
  }

  .footer-actions,
  .upload-grid {
    flex-direction: column;
  }

  .proof-card,
  .footer-btn,
  .mini-primary-btn {
    width: 100%;
  }
}
</style>
